/**
 * Snapshot API Service
 *
 * 處理 Double11 Snapshot API 呼叫
 * Endpoint: https://freeanalysisapi.turingdigital.com.tw/double11/snapshot
 */

const API_ENDPOINT = 'https://freeanalysisapi.turingdigital.com.tw/double11/snapshot'

/**
 * 呼叫 Snapshot API
 *
 * @param {string} email - 使用者 email
 * @param {string} propertyId - GA4 Property ID
 * @returns {Promise<Object>} API 回傳資料
 */
export const fetchSnapshot = async (email, propertyId) => {
  try {
    // 驗證參數
    if (!email || !propertyId) {
      throw new Error('Email and PropertyID are required')
    }

    // 移除 "properties/" 前綴 (如果有的話)
    const cleanPropertyId = propertyId.replace('properties/', '')

    console.log('📤 Snapshot API Request:', {
      email,
      PropertyID: cleanPropertyId,
      date: Date.now().toString()
    })

    // 準備表單資料 (application/x-www-form-urlencoded)
    const formData = new URLSearchParams()
    formData.append('email', email)
    formData.append('PropertyID', cleanPropertyId)
    formData.append('date', Date.now().toString())

    console.log('📤 Request body:', formData.toString())

    // 發送 POST request
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formData.toString(),
    })

    // 檢查 HTTP 狀態
    if (!response.ok) {
      // 嘗試獲取錯誤詳情
      let errorDetail = ''
      try {
        const errorData = await response.json()
        errorDetail = JSON.stringify(errorData)
        console.error('❌ API Error Response:', errorData)
      } catch (e) {
        const errorText = await response.text()
        errorDetail = errorText
        console.error('❌ API Error Text:', errorText)
      }
      throw new Error(`HTTP error! status: ${response.status}, detail: ${errorDetail}`)
    }

    // 先取得文字內容
    const text = await response.text()

    // 檢查是否為 "no data"
    if (text === 'no data' || text.toLowerCase().trim() === 'no data') {
      console.warn('⚠️ API Response: no data')
      return { _noData: true } // 回傳特殊標記
    }

    // 嘗試解析 JSON
    try {
      const data = JSON.parse(text)
      console.log('✅ API Success Response:', data)
      return data
    } catch (parseError) {
      console.error('❌ JSON Parse Error:', parseError.message)
      throw new Error(`Failed to parse JSON response: ${parseError.message}`)
    }
  } catch (error) {
    // 錯誤只印在 console,不顯示給使用者
    console.error('Snapshot API Error:', {
      email,
      propertyId,
      error: error.message,
      stack: error.stack,
    })

    // 重新拋出錯誤,讓呼叫端可以處理
    throw error
  }
}

/**
 * 預設匯出
 */
export default {
  fetchSnapshot,
}
